import axios from 'axios';
import { backend } from '../constants/api';
import { logout } from '../utils/auth';
import { scopeFromRequest } from '../collaboration/scopes';
import {
  clearConflict,
  markClean,
  setConflict,
  setVersion,
  versionIfKnown,
} from '../collaboration/store';

const urlBase = backend;

/**
 * Añade la versión del formulario al guardado y traduce el 409 del servidor a
 * un resultado con `conflict`, para que el formulario avise en vez de pisar el
 * trabajo de otro perito. Devuelve el body original si no es un guardado.
 *
 * La versión solo se manda si el cliente ya la conoce del servidor (llegó el
 * snapshot de colaboración); si no, el guardado viaja sin validar.
 */
function withCollaboration(url, body) {
  const scope = scopeFromRequest(url, body);
  if (!scope || !body || typeof body !== 'object' || Array.isArray(body)) {
    return { body, scope: null };
  }

  const version = versionIfKnown(scope);
  if (version === undefined) return { body, scope };

  return { body: { ...body, __version: version }, scope };
}

function handleSaveResponse(response, scope) {
  if (!scope) return response.data;

  if (response.status === 409) {
    setConflict(scope, {
      message: response.data && response.data.message,
      server_version: response.data && response.data.data
        ? response.data.data.server_version
        : undefined,
    });
    return {
      success: false,
      conflict: true,
      message:
        (response.data && response.data.message) ||
        'Este formulario cambió mientras lo editabas.',
    };
  }

  if (response.data && response.data.success) {
    const data = response.data.data || {};
    if (data.version !== undefined) setVersion(scope, data.version);
    markClean(scope);
    clearConflict(scope);
  }
  return response.data;
}

export const get = async (url, header, params) => {
  const token = localStorage.getItem('token');
  const headers = { ...header };
  headers['Content-Type'] = 'text/html; charset=utf-8';
  const currentDate = Date.now();
  // headers['Access-Control-Allow-Origin'] = 'http://localhost';
  if (token) headers['Authorization'] = `Bearer ${token}`;

  try {
    const long_url = urlBase + url + `?date=${currentDate}`;
    const res = await axios.get(long_url, { headers: headers, params });
    if (res.data) return res.data;
    console.error(res);
    return {
      success: false,
      message: res.message,
    };
  } catch (error) {
    console.error(error);
    if (error?.response?.status === 401) logout();
    return {
      success: false,
      message: error.message,
    };
  }
};

export const del = async (url, header) => {
  const token = localStorage.getItem('token');
  const headers = {};
  headers['Content-Type'] = 'text/html; charset=utf-8';
  const currentDate = Date.now();
  // headers['Access-Control-Allow-Origin'] = 'http://localhost';
  if (token) headers['Authorization'] = `Bearer ${token}`;

  try {
    const long_url = urlBase + url + `?date=${currentDate}`;
    const res = await axios.delete(long_url, { headers: headers });
    if (res.data) return res.data;
    console.error(res);
    return {
      success: false,
      message: res.message,
    };
  } catch (error) {
    console.error(error);
    if (error?.response?.status === 401) logout();
    return {
      success: false,
      message: error.message,
    };
  }
};

export const post = async (url, body, header) => {
  const token = localStorage.getItem('token');
  const headers = {};
  headers['Content-Type'] = 'application/json; charset=utf-8';
  const currentDate = Date.now();
  // headers['Access-Control-Allow-Origin'] = 'http://localhost';
  if (token) headers['Authorization'] = `Bearer ${token}`;

  const tracked = withCollaboration(url, body);

  try {
    const long_url = urlBase + url + `?date=${currentDate}`;
    const res = await axios.post(long_url, tracked.body, { headers });
    if (res.data) return handleSaveResponse(res, tracked.scope);
    console.error(res);
    return {
      success: false,
      message: res.message,
    };
  } catch (error) {
    console.error(error);
    if (error?.response?.status === 401) logout();
    if (error?.response?.status === 409) return handleSaveResponse(error.response, tracked.scope);
    return {
      success: false,
      message: error.message,
    };
  }
};

export const put = async (url, body, header) => {
  const token = localStorage.getItem('token');
  const headers = {};
  headers['Content-Type'] = 'application/json; charset=utf-8';
  const currentDate = Date.now();
  // headers['Access-Control-Allow-Origin'] = 'http://localhost';
  if (token) headers['Authorization'] = `Bearer ${token}`;

  try {
    const long_url = urlBase + url + `?date=${currentDate}`;
    const res = await axios.put(long_url, body, { headers });
    if (res.data) return res.data;
    return {
      success: false,
      message: res.message,
    };
  } catch (error) {
    console.error(error);
    if (error?.response?.status === 401) logout();
    return {
      success: false,
      message: error.message,
    };
  }
};
